//import './app/menu';
import './app/request-posts';
import './app/filter-events';
import './app/filter-magazine';
import './app/filter-tv';
import './app/filter-company-guide';
import './app/menu-digitalks';
import './app/header-digitalks';
import './app/infinity-scroll';
import './app/infinity-scroll-solucoes';
import './app/attributeTitles';
import './app/loadmore';
